import { jsx } from 'react/jsx-runtime';
import { usePulseSettings } from '@pulse/react';
import data from '../headerNavigation/index.js';
import { H as Header } from '../styles-4a961839.js';
import '../tslib.es6-c6da0ae6.js';
import 'classnames';
import '@picsart/rc/services/localization';
import '@picsart/rc/services/analytics';
import '@picsart/design-system/foundation/logos';
import '@picsart/design-system/foundation/icons/IconCompanySymbol';
import '@picsart/design-system/components/Button';
import '@picsart/design-system/foundation/colors';
import '../authContext-a01efdfb.js';
import '../HeaderSkeleton-30c00961.js';
import 'react';
import '@picsart/rc/useMount';
import '@picsart/design-system/foundation/icons/IconNotification';
import '../isBrowser/index.js';
import '@picsart/design-system/foundation/icons/IconComment';
import '../styles-92b38f47.js';
import 'react-intersection-observer';
import '@picsart/design-system/foundation/icons/IconCrossCircleFilled';
import '../types-299e9037.js';
import '../configs/constants/index.js';
import '../constants-e3c79897.js';
import '../constants-8010f63c.js';
import '../services/errorLogger/index.js';
import '../services/logger/index.js';
import '../models/user/index.js';
import '../requestFactory-4dc9ec32.js';
import '../detectIncognito.esm-e89d4263.js';
import '../data-dab7692c.js';
import '@picsart/design-system/foundation/typography';
import '@picsart/design-system/components/Text';
import '@picsart/design-system/foundation/fonts';
import '@picsart/design-system/foundation/responsive';
import '@picsart/design-system/foundation/icons/IconChevronLeftLarge';
import '../SanitizeHtml-299f5620.js';
import 'isomorphic-dompurify';
import '@picsart/design-system/foundation/icons/IconApple';
import '@picsart/design-system/foundation/icons/IconEmail';
import '@picsart/design-system/foundation/icons/IconFacebookColored';
import '@picsart/design-system/foundation/icons/IconGoogleColored';
import 'react-jss';
import '@picsart/rc/services/http';
import 'react-dom';
import '../services/auth/index.js';
import '../styles-59499c92.js';
import '@picsart/design-system/components/Overlay';
import '@picsart/rc/enums';
import '@picsart/design-system/foundation/icons/IconArrowDownFilled';
import '@picsart/design-system/foundation/icons/IconArrowUpFilled';
import '@picsart/rc/old/Loading';
import '@picsart/design-system/components/Tooltip';
import '@picsart/rc/convertSpacesToUnderlines';
import '@picsart/rc/analyticsLogout';
import '@picsart/design-system/components/Skeleton';
import '@picsart/design-system/foundation/icons/IconCoins';
import '@picsart/design-system/foundation/icons/IconCloudInfo';
import '@picsart/design-system/components/Badge';
import '@picsart/design-system/components/Avatar';
import '../general-9698471b.js';
import '../services/http/index.js';
import '@picsart/design-system/foundation/icons/IconChevronRightOutline';
import '@picsart/design-system/foundation/icons/IconSearch';
import '@picsart/rc/generateUUID';
import '@picsart/design-system/foundation/cornerRadius';
import '@picsart/design-system/foundation/icons/IconImage';
import '@picsart/design-system/components/Image';
import '../enums-f1259a13.js';
import '@picsart/rc/noop';
import '@picsart/design-system/components/TextField';
import '@picsart/design-system/foundation/icons/IconCrossLarge';
import '@picsart/design-system/foundation/icons/IconTshirt';
import '@picsart/rc/useDevice';
import '@picsart/design-system/components/HorizontalContainer';

var Skeleton = function Skeleton() {
  return jsx("div", {
    "data-testid": "skeleton",
    style: {
      height: 80
    }
  });
};
var HeaderWithSkeleton = function HeaderWithSkeleton(props) {
  var _a = usePulseSettings({
      name: 'header_navigation_json',
      tag: 'navigation'
    }),
    loading = _a.loading,
    settings = _a.settings,
    hasError = _a.hasError;
  if (hasError) {
    return null;
  }
  if (loading) {
    return jsx(Skeleton, {});
  }
  return jsx(Header, {
    data: !loading && (settings || data),
    applicationName: props.applicationName,
    hideAppBanner: props.hideAppBanner,
    promoBannerProps: props.promoBannerProps,
    storageData: props.storageData,
    creditsData: props.creditsData,
    hideNavigation: props === null || props === void 0 ? void 0 : props.hideNavigation,
    hideSearchButton: props.hideSearchButton,
    showProfileFeed: props.showProfileFeed,
    showReferToEarn: props.showReferToEarn,
    logoBehavior: props === null || props === void 0 ? void 0 : props.logoBehavior,
    isMaximizer: props === null || props === void 0 ? void 0 : props.isMaximizer
  });
};

export { HeaderWithSkeleton as default };
//# sourceMappingURL=index.js.map
